export const config = {
     variableWidth: true,
     infinite: false,
     slidesToShow: 3,
     slidesToScroll: 1,
     prevArrow: '<button class="slick-prev" aria-label="Previous" type="button"><img src="/assets/img/icons/icon_dark_arrowprev@3x.svg" alt="Previous"/></button>',
     nextArrow: '<button class="slick-next" aria-label="Next" type="button"><img src="/assets/img/icons/icon_dark_arrownext@3x.svg" alt="Next"/></button>',
     responsive: [
          {
               breakpoint: 1105,
               settings: {
                    slidesToShow: 2,
               }
          },
          {
               breakpoint: 725,
               settings: {
                    slidesToShow: 1,
               }
          }
     ],
};
